import { render, staticRenderFns } from "./SocialNetworks.vue?vue&type=template&id=46f27ce9&scoped=true"
import script from "./SocialNetworks.vue?vue&type=script&lang=js"
export * from "./SocialNetworks.vue?vue&type=script&lang=js"
import style0 from "./SocialNetworks.vue?vue&type=style&index=0&id=46f27ce9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f27ce9",
  null
  
)

export default component.exports